import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_MONITOR_DATA,
} from '../../../../actions/actionTypes';

const contentLinkMonitorData = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_MONITOR_DATA
);

export default contentLinkMonitorData;
